import translations from './boron.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/boron'

export const boron: Metal = {
  id: 40,
  slug: 'boron',
  name: t.name,
  symbol: 'B',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Kırka, boron mine (Turkey)',
      region: t.mine0Region,
      slug: 'kirka',
      coordinates: [30.52, 39.28],
    },
    {
      name: 'Boron, boron mine (United States)',
      region: t.mine1Region,
      slug: 'boron',
      coordinates: [-117.65, 35.0],
    },
    {
      name: 'Emet, boron mine (Turkey)',
      region: t.mine2Region,
      slug: 'emet',
      coordinates: [29.26, 39.34],
    },
    {
      name: 'Bigadiç, boron mine (Turkey)',
      region: t.mine3Region,
      slug: 'bigadic',
      coordinates: [28.13, 39.39],
    },
    {
      name: 'Dalnegorsk, boron mine (Russia)',
      region: t.mine4Region,
      slug: 'dalnegorsk',
      coordinates: [135.57, 44.56],
    },
  ],
  // Sheet gives volumes only (Turkey ~3,000 kt, Chile ~420, China ~340, Peru ~300),
  // and MinePills renders percentages.
  countries: [],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'camera'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: null, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
      ],
    },
  },
}
